import { _getAllDiet } from "../constants/api";

export const getDiet = async (data) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));
    const token = userData?.token;

    if (!token) {
      throw new Error("Token not found");
    }
    const response = await fetch(
      `${_getAllDiet}/get-users-diet?fromdate=${data.fromDate}&todate=${data.toDate}&userid=${data.userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          clientid: "e0ce9cb8-430e-4148-b562-b8833cc9fa0b",
        },
      })
    const responseJSON = await response.json();
    return responseJSON;
  } catch {
    alert('Error occured in the get diet api')
  }
}
